export enum DoorType {
  n2 = 'n2',
  n3 = 'n3',
  n4 = 'n4',
  n5 = 'n5',
  other = 'other',
  unknown = 'unknown',
}

// when somebody adds a truck we 2-door, ext. cab, 4-door
export enum TruckDoorType {
  n2 = '2-Door',
  ext = 'Extended Cab',
  n4 = '4-Door',
}

export const DoorTypeValues: { [key in DoorType]: string } = {
  n2: '2-Door',
  n3: '3-Door',
  n4: '4-Door',
  n5: '5-Door',
  other: 'Other',
  unknown: 'Unknown',
};

export const fromDoorTypeValue = (value: string) => {
  switch (value) {
    case '2-Door':
      return DoorType.n2;
    case '3-Door':
      return DoorType.n3;
    case '4-Door':
      return DoorType.n4;
    case '5-Door':
      return DoorType.n5;
    case 'Other':
      return DoorType.other;
    case 'Unknown':
      return DoorType.unknown;
    default:
      throw new Error(`invalid DoorType value: ${value}`);
  }
};
